import { NotificationType } from '@tabeeb/enums'

export const reminderNotifications = [NotificationType.AnswerQuestionReminder]
